<template>
  <div class="pager-bar">
    <div class="summary"><slot name="summary" /></div>
    <div class="pager">
      <span class="pageinfo">页码 {{ current }}/{{ pageCount }} 共 {{ total }} 条</span>
      <Page
        :total="total"
        :current="current"
        :page-size="pageSize"
        :page-size-opts="pageSizeOpts"
        show-sizer show-elevator size="small"
        @on-change="(p) => $emit('change', p)"
        @on-page-size-change="(s) => $emit('page-size', s)"
      />
    </div>
  </div>
</template>

<script>
// 通用分页汇总条(收敛各列表页手写的 .total/.pager/.pageinfo + iView Page)
// 左侧 summary slot 放页面自定义汇总文案;分页交互统一抛 change / page-size 事件。
export default {
  name: 'Pager',
  props: {
    total: { type: Number, default: 0 },
    current: { type: Number, default: 1 },
    pageSize: { type: Number, default: 15 },
    pageSizeOpts: { type: Array, default: () => [15, 30, 50, 100] }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.pager-bar {
  display: flex; align-items: center; justify-content: space-between;
  background: @bg-white; padding: 10px 12px; border-radius: @radius; margin-top: 10px;
}
.summary { color: @text-main; font-weight: 600; }
.pager { display: flex; align-items: center; gap: 12px; }
.pageinfo { color: @text-sub; }
</style>
